export const ADD_USER = 'ADD_USER';
export const ADD_USER_CREDENTIALS_ERROR = 'ADD_USER_CREDENTIALS_ERROR';
export const LIST_SORACOM_USERS = 'LIST_SORACOM_USERS';
export const CLEAR_SORACOM_USERS = 'CLEAR_SORACOM_USERS';
